<template>
    <div>
        <div class="col-12 col-sm-10 offset-sm-1 col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3 avp-logo">
            <AnimodLogo alt="Logo der Animod GmbH" class="icon logo"/>
        </div>
        <div class="col-12">
            <h1>Willkommen im Anfrage–Portal von Animod</h1>
        </div>
    </div>
</template>

<script>
import AnimodLogo from '@/assets/animod_logo_variations.svg';
export default {
  name: 'CardHeader',
    components: {
        AnimodLogo
    },
  computed: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    h1 {
        color: #515151;
        display: block;
        font-size: 1.5rem;
        margin: 0.625rem auto;
        text-align: center;
    }

    .avp-card-header {
        .avp-logo {
            .logo {
                display: block;
                height: 3.75rem;
                margin: 0 auto;
                max-width: 100%;
                color: hsl(0, 0%, 32%);

                @media (min-width: 576px) {
                    height: 3.75rem;
                }
                @media (min-width: 768px) {
                    height: 2.5rem;
                }
                @media (min-width: 992px) {
                    height: 5rem;
                }
                @media (min-width: 1200px) {
                    height: 6.25rem;
                }
            }

            h1 {
                color: #515151;
                display: block;
                font-size: 1.5rem;
                margin: 0.625rem auto;
                text-align: center;
            }
        }
    }
</style>
